const FILTER_MAX_DISTANCE = "30";

export const formatTHCFilterKey = (
  values: string,
  index = 0
): { [key: string]: string } => {
  const [gte, lte] = values.replace("*", "").split("-");

  const formattedFilter: { [key: string]: string } = {};
  if (gte) {
    formattedFilter[`filter[thc][${index}][gte]`] = gte;
  }
  if (lte) {
    formattedFilter[`filter[thc][${index}][lte]`] = lte;
  }
  return formattedFilter;
};

export const formatFilterKey = (
  key: string,
  value: string,
  enableNewFilters?: boolean,
  index?: number
): { [key: string]: string | boolean } => {
  switch (key) {
    case "effects_included":
      return {
        [`filter[effects.${value}]`]: true,
      };
    case "effects_excluded":
      return {
        [`filter[effects.${value}]`]: false,
      };
    case "flavors_included":
      return {
        [`filter[flavors.${value}]`]: true,
      };
    case "conditions_included":
      return {
        [`filter[conditions.${value}]`]: true,
      };
    case "symptoms_included":
      return {
        [`filter[symptoms.${value}]`]: true,
      };
    case "negatives_excluded":
      return {
        [`filter[negatives.${value}]`]: false,
      };
    case "phenotype":
      return {
        [`filter[strain_category][]`]: value.replace(/\b\w/g, (c) =>
          c.toUpperCase()
        ),
      };
    case "strain_top_terp":
      return {
        [`filter[strain_top_terp][]`]: value,
      };
    case "online_fulfillment_enabled":
      return {
        [`filter[max_distance]`]: FILTER_MAX_DISTANCE,
        [`filter[online_fulfillment_enabled]`]: true,
      };
    case "thc_ranges":
      return enableNewFilters
        ? { [`filter[thc]`]: value }
        : formatTHCFilterKey(value, index);
    default:
      return {
        [`filter[${key}][]`]: value,
      };
  }
};

export const formatSortParam = (value: string) => {
  const [query, direction] = value.split(":");
  return { [`sort[0][${query}]`]: direction };
};
